<template>
  <Component
    :is="props.is"
    class="wrapper"
    @click="emit('wrapper:click')"
  >
    <slot />
  </Component>
</template>

<script setup>
// Emitter
const emit = defineEmits([
  'wrapper:click',
])

// Props
const props = defineProps({
  is: {
    default() {
      return 'div'
    },
    required: false,
    type: String,
    validator(value) {
      return ['dialog', 'div', 'footer', 'header', 'main'].indexOf(value) !== -1
    },
  },
})
</script>

<style lang="postcss" scoped>
.wrapper {
  @apply flex w-full max-w-[100vw] box-border;
}
</style>
